import { defineComponent, PropType, ref, onMounted, onUnmounted, Teleport } from 'vue'
import styles from './style.module.scss'

export default defineComponent({
  name: 'RightCornerWidget',
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    isXinfa: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const componentsConfig: any = window.NSComponentsConfig
    const configs = componentsConfig?.data_default?.properties.swipe_list as {
      item_url: string
      interval: number
    }[]

    const currentIndex = ref(0)
    const interval = ref<number | null>(null)
    const isTransitioning = ref(false)

    const handleNext = () => {
      if (!configs || configs.length <= 1) return

      // 开始过渡
      isTransitioning.value = true

      // 等待过渡完成后更新索引
      setTimeout(() => {
        // 更新索引, 渲染下一个二维码
        currentIndex.value = (currentIndex.value + 1) % configs.length

        // 过渡结束 50ms 防止闪烁
        setTimeout(() => {
          isTransitioning.value = false

          // 重新开始自动播放
          startAutoplay()
        }, 50)
      }, 800)
    }

    const startAutoplay = () => {
      if (!configs || configs.length <= 1) return

      stopAutoplay()

      // 获取当前二维码的展示时长
      const currentDuration = configs[currentIndex.value]?.interval || 5000

      interval.value = window.setInterval(() => {
        handleNext()
      }, currentDuration)
    }

    const stopAutoplay = () => {
      if (interval.value) {
        clearInterval(interval.value)
        interval.value = null
      }
    }

    onMounted(() => {
      startAutoplay()
    })

    onUnmounted(() => {
      stopAutoplay()
    })

    return () => {
      if (!props.show || !configs || configs.length === 0) return null

      const currentConfig = configs[currentIndex.value]

      return (
        // 使用Teleport组件将组件挂载到body元素上，避免position: fixed 导致组件在安卓大屏被遮挡
        <Teleport to="body">
          <div
            class={[styles.widgetContainer, props.isXinfa ? styles.widgetContainerXinfa : '']}
          >
            <div class={props.isXinfa ? styles.rightCornerWidgetXinfa : styles.rightCornerWidget}>
              <div
                class={styles.qrcodeContainer}
                style={{
                  opacity: isTransitioning.value ? 0 : 1,
                }}
              >
                <img src={currentConfig.item_url} alt={`二维码-${currentIndex.value}`}></img>
              </div>
            </div>
          </div>
        </Teleport>
      )
    }
  },
})
